import { Koi } from '@ksyos/koi';
import type { IDeviceStatusWithOrganizations } from '@common/interfaces/deviceStatusWithOrganizations';
import { EpisodeCategory } from '@common/enums';
import type { ISchemaContainer } from './schemaContainer';
import { DeviceStatus } from '../enums/deviceStatus';
import { deviceStatusSchema } from './deviceStatus';

export interface IDeviceAddEditValidated {
    deviceStatusWithOrganizations: IDeviceStatusWithOrganizations;
    deviceTypeId: string;
    externalId: string;
    notes: string | null;
}

export const deviceAddSchema: ISchemaContainer<IDeviceAddEditValidated> = {
    schema: Koi.object({
        deviceStatusWithOrganizations: Koi.object({
            deviceStatus: deviceStatusSchema,
            organizationIds: Koi.when('deviceStatus.status', {
                is: DeviceStatus.issued,
                otherwise: Koi.array().length(0),
                then: Koi.array().items(Koi.string().uuid()).min(1),
            }),
        }),
        deviceTypeId: Koi.string().uuid(),
        externalId: Koi.string().trim().max(30),
        notes: Koi.string().max(255).allow(null),
    }).options({ convert: false, presence: 'required' }),
};

export const deviceEditSchema = Koi.object({
    deviceTypeId: Koi.string().required(),
    externalId: Koi.string().trim().max(30).required(),
    notes: Koi.string().max(255).allow(''),
});

export const deviceFiltersValidation = Koi.object({
    deviceStatuses: Koi.array().items(Koi.koi().enum(DeviceStatus)).allow(null),
    deviceTypes: Koi.array().items(Koi.string().uuid()).allow(null),
    episodeCategories: Koi.array().items(Koi.koi().enum(EpisodeCategory)).allow(null),
    searchText: Koi.string().max(255).allow(null, ''),
});

export interface IDeviceFilters {
    deviceStatuses?: DeviceStatus[];
    deviceTypes?: string[];
    episodeCategories?: EpisodeCategory[];
    searchText?: string | null;
}
